import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { FriendSelectList, WalletSelectList, Wallets } from '@app/shared/models';
import { WalletPublicService } from '@app/shared/services';
import { InlineAlertTypes } from '@app/shared/types/inline-alert-types';
import { TranslateModule } from '@ngx-translate/core';
import { AngularResizeEventModule, ResizedEvent } from 'angular-resize-event';
import { finalize, take } from 'rxjs';
import { TableLoadingComponent } from '../../table-loading/table-loading.component';

@Component({
    selector: 'tc-select-third-party-wallet-list',
    imports: [
        CommonModule,
        TranslateModule,
        TableLoadingComponent,
        AngularResizeEventModule
    ],
    templateUrl: './select-third-party-wallet-list.component.html',
    styleUrls: ['./select-third-party-wallet-list.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class SelectThirdPartyWalletListComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild('wallets') walletsView: ElementRef;
  @Output() selectedWalletEmit = new EventEmitter<WalletSelectList>();
  @Input() selectedFriend: FriendSelectList;
  @Input() accountNumber: string;
  @Input() fromWallet: string;
  @Input() showCrypto: boolean = false;

  // data
  friendWallets: Wallets;
  selectedWallet: WalletSelectList;

  // boolean
  isLoading: boolean;
  walletClass: string;

  // types
  inlineAlertTypes = InlineAlertTypes;

  constructor(
    private walletPublicService: WalletPublicService,
    private cdr: ChangeDetectorRef
  ) { }



  ngOnInit() {
    this.onSelectedFriendChanged();

  }



  ngAfterViewInit(): void {
    if (this.walletsView) {
      this.walletClass = this.getClass(this.walletsView.nativeElement.offsetWidth);
      this.cdr.detectChanges();
    }
  }

  ngOnChanges(): void {
    this.onSelectedFriendChanged();
  }

  private onSelectedFriendChanged(): void {
    this.isLoading = true;
    this.walletPublicService.getFriendList(this.selectedFriend.friendshipId, this.fromWallet)
      .pipe(
        take(1),
        finalize(() => this.isLoading = false)
      )
      .subscribe(friendWallet => {
        this.friendWallets = friendWallet;

        this.checkIfHaveDefualtSelectedWallet();
      });
  }

  private checkIfHaveDefualtSelectedWallet(): void {
    if (this.accountNumber) {
      this.selectedWallet = this.friendWallets.fiat.list.find(item => item.accountNumber === this.accountNumber);
      if (!this.selectedWallet) {
        this.selectedWallet = this.friendWallets.crypto.list.find(item => item.accountNumber === this.accountNumber);
      }
      this.selectedWalletEmit.emit(this.selectedWallet);
    }
  }

  selectWallet(wallet: WalletSelectList): void {
    this.selectedWallet = wallet;
    this.selectedWalletEmit.emit(wallet);
  }


  /*******************************************************************
   Style
  *******************************************************************/

  onResized(event: ResizedEvent) {
    this.walletClass = this.getClass(event.newRect.width);
  }

  private getClass(width: number): string {
    if (width < 510) {
      return 'wallet-xs';

    } else if (width > 509 && width < 728) {
      return 'wallet-sm';

    } else if (width > 727 && width < 1027) {
      return ('wallet-md');

    } else if (width > 1026 && width < 1500) {
      return 'wallet-lg';

    } else if (width > 1499) {
      return 'wallet-xl';

    }
  }

}
